"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiAuthStrategy = exports.defaultAuthStrategy = void 0;
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var defaultAuthStrategy_1 = require("./defaultAuthStrategy");
Object.defineProperty(exports, "defaultAuthStrategy", { enumerable: true, get: function () { return defaultAuthStrategy_1.defaultAuthStrategy; } });
var multiAuthStrategy_1 = require("./multiAuthStrategy");
Object.defineProperty(exports, "multiAuthStrategy", { enumerable: true, get: function () { return multiAuthStrategy_1.multiAuthStrategy; } });
